import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const CertificatesTab = () => {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [links, setLinks] = useState({});
  const [numbers, setNumbers] = useState({});
  const load = () => api.get("/admin/passed-candidates").then((r) => setRows(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (r, sent) => {
    try {
      const certificate_url = (links[r.enrollment_id] ?? r.certificate_url ?? "").trim();
      const certificate_number = (numbers[r.enrollment_id] ?? r.certificate_number ?? "").trim();
      const { data } = await api.post(`/admin/enrollments/${r.enrollment_id}/certificate-sent`, { sent, certificate_url, certificate_number });
      toast.success(!sent ? "Marked as not sent" : data.emailed ? "Certificate saved - candidate emailed" : "Certificate details updated");
      setLinks((l) => { const n = { ...l }; delete n[r.enrollment_id]; return n; });
      setNumbers((l) => { const n = { ...l }; delete n[r.enrollment_id]; return n; });
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Failed"); }
  };

  const shown = rows.filter((r) => filter === "all" || (filter === "pending" ? !r.certificate_sent_at : r.certificate_sent_at));
  const pendingCount = rows.filter((r) => !r.certificate_sent_at).length;

  return (
    <div data-testid="admin-certificates-tab">
      <div className="flex items-center gap-2 mb-4 flex-wrap">
        {[["pending", `Not yet sent (${pendingCount})`], ["sent", "Sent"], ["all", `All passed (${rows.length})`]].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} className={`chip text-xs ${filter === k ? "bg-[var(--navy)] text-white border-[var(--navy)]" : ""}`} data-testid={`cert-filter-${k}`}>{l}</button>
        ))}
      </div>
      {shown.length === 0 ? (
        <div className="card-warm p-6 text-sm text-zinc-500" data-testid="cert-empty">No candidates in this view.</div>
      ) : (
        <div className="card-warm divide-y divide-[var(--border-warm)]">
          {shown.map((r) => (
            <div key={r.enrollment_id} className="p-4 flex items-center justify-between gap-3 flex-wrap" data-testid={`cert-row-${r.enrollment_id}`}>
              <div className="min-w-0">
                <div className="font-semibold text-sm">{r.user_name} <span className="text-zinc-500 font-normal">· {r.user_email}</span></div>
                <div className="text-xs text-zinc-600">{r.course_code} - {r.course_title} · PASS{r.best_percent != null ? ` ${r.best_percent}%` : ""}{r.passed_at ? ` · ${r.passed_at.slice(0, 10)}` : ""}</div>
                {r.certificate_sent_at && <div className="text-[11px] text-emerald-700 mt-0.5">Sent {new Date(r.certificate_sent_at).toLocaleDateString()} by {r.certificate_sent_by_name}{r.certificate_number && <> · No. <span className="font-mono">{r.certificate_number}</span></>}{r.certificate_url && <> · <a href={r.certificate_url} target="_blank" rel="noreferrer" className="underline">view link</a></>}</div>}
              </div>
              <div className="flex items-center gap-2 flex-wrap w-full sm:w-auto">
                <input
                  value={numbers[r.enrollment_id] ?? r.certificate_number ?? ""}
                  onChange={(e) => setNumbers({ ...numbers, [r.enrollment_id]: e.target.value })}
                  placeholder="Certificate no."
                  className="w-36 min-w-0 p-2 text-xs font-mono uppercase border border-[var(--border-warm)] rounded-lg"
                  data-testid={`cert-number-input-${r.enrollment_id}`}
                />
                <input
                  type="url"
                  value={links[r.enrollment_id] ?? r.certificate_url ?? ""}
                  onChange={(e) => setLinks({ ...links, [r.enrollment_id]: e.target.value })}
                  placeholder="https://… certificate link (optional)"
                  className="flex-1 sm:w-72 min-w-0 p-2 text-xs border border-[var(--border-warm)] rounded-lg"
                  data-testid={`cert-link-input-${r.enrollment_id}`}
                />
                {r.certificate_sent_at && ((links[r.enrollment_id] !== undefined && links[r.enrollment_id] !== (r.certificate_url || "")) || (numbers[r.enrollment_id] !== undefined && numbers[r.enrollment_id] !== (r.certificate_number || ""))) && (
                  <button onClick={() => save(r, true)} className="chip text-xs" data-testid={`cert-link-save-${r.enrollment_id}`}>Save</button>
                )}
                <label className="inline-flex items-center gap-2 text-sm cursor-pointer whitespace-nowrap">
                  <input type="checkbox" checked={!!r.certificate_sent_at} onChange={() => save(r, !r.certificate_sent_at)} className="w-4 h-4" data-testid={`cert-sent-toggle-${r.enrollment_id}`}/>
                  Certificate sent
                </label>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
